(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    class ProductMediaGallery {
    constructor(container) {
      this.container = container;
      this.slideshow = container.querySelector('[data-slideshow]');
      this.slides = [...container.querySelectorAll('[data-slide-index]')];
      this.dots = [...container.querySelectorAll('.product-media-gallery__dot')];
      this.thumbs = [...container.querySelectorAll('.product-media-gallery__thumbnail')];
      this.prevBtn = container.querySelector('[data-slideshow-prev]');
      this.nextBtn = container.querySelector('[data-slideshow-next]');
      this.currentIndex = 0;
      this.totalSlides = this.slides.length;
      this.autoplayInterval = null;
      this.autoplayDelay = 4000;

      this.init();
    }

    init() {
      if (this.totalSlides <= 1) return;

      // Remove any blank slides (no <img> tag)
      this._removeBlankSlides();

      // Re-check after cleanup
      if (this.totalSlides <= 1) return;

      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());

      this.dots.forEach(dot => {
        dot.addEventListener('click', () => {
          this.goTo(parseInt(dot.dataset.slideIndex));
        });
      });

      this.thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
          this.goTo(parseInt(thumb.dataset.slideIndex));
        });
      });

      // Set initial aspect ratio to match first image
      this._updateContainerAspectRatio(0);

      this.startAutoplay();

      if (this.slideshow) {
        this.slideshow.addEventListener('mouseenter', () => this.stopAutoplay());
        this.slideshow.addEventListener('mouseleave', () => this.startAutoplay());
      }

      // Re-check for blank slides after all images load
      window.addEventListener('load', () => {
        setTimeout(() => this._removeBlankSlides(), 500);
      });
    }

    _removeBlankSlides() {
      let changed = false;
      const slides = [...this.slides];

      slides.forEach((slide) => {
        const img = slide.querySelector('img[data-media-image]');
        if (!img) {
          console.warn('[Gallery] Removing blank slide (no img):', slide.dataset.slideIndex);
          slide.remove();
          changed = true;
        }
      });

      if (changed) {
        // Refresh all references
        this.slides = [...this.container.querySelectorAll('[data-slide-index]')];
        this.dots = [...this.container.querySelectorAll('.product-media-gallery__dot')];
        this.thumbs = [...this.container.querySelectorAll('.product-media-gallery__thumbnail')];
        this.totalSlides = this.slides.length;

        // Re-index
        this.slides.forEach((s, i) => { s.dataset.slideIndex = String(i); });
        this.dots.forEach((d, i) => { d.dataset.slideIndex = String(i); });
        this.thumbs.forEach((t, i) => { t.dataset.slideIndex = String(i); });

        // Clamp current index
        if (this.currentIndex >= this.totalSlides) this.currentIndex = 0;
        if (this.totalSlides > 0) this.goTo(this.currentIndex);
      }
    }


    goTo(index) {
      if (this.totalSlides <= 1) return;

      if (index < 0) index = this.totalSlides - 1;
      if (index >= this.totalSlides) index = 0;

      this.currentIndex = index;

      this.slides.forEach((slide, i) => {
        const isActive = i === index;
        slide.style.display = isActive ? 'flex' : 'none';
        slide.classList.toggle('is-active', isActive);
      });

      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });

      this.thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index);
      });

      // Update container aspect ratio to match current image
      this._updateContainerAspectRatio(index);
    }

    _updateContainerAspectRatio(index) {
      if (!this.slideshow) return;
      const slide = this.slides[index];
      if (!slide) return;

      const img = slide.querySelector('img[data-media-image]');
      if (img && img.naturalWidth > 0) {
        const ratio = img.naturalWidth / img.naturalHeight;
        if (ratio > 0.2 && ratio < 5) {
          this.slideshow.style.aspectRatio = ratio.toFixed(4);
        }
      } else if (img) {
        img.addEventListener('load', () => {
          const r = img.naturalWidth / img.naturalHeight;
          if (r > 0.2 && r < 5) {
            this.slideshow.style.aspectRatio = r.toFixed(4);
          }
        });
      }
    }

    next() { this.goTo(this.currentIndex + 1); }
    prev() { this.goTo(this.currentIndex - 1); }

    startAutoplay() {
      this.stopAutoplay();
      if (this.totalSlides <= 1) return;
      this.autoplayInterval = setInterval(() => this.next(), this.autoplayDelay);
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-media-gallery').forEach(g => {
      new ProductMediaGallery(g);
    });
  });

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('.product-media-gallery').forEach(g => {
      new ProductMediaGallery(g);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
